import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutBottomFull: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLayoutBottomFull"><Path d="M20.5 20.5V21H21V20.5H20.5ZM20.5 3.5H21V3H20.5V3.5ZM3.5 3.5V3H3V3.5H3.5ZM3.5 20.5H3V21H3.5V20.5ZM21 20.5V3.5H20V20.5H21ZM20.5 3H3.5V4H20.5V3ZM3 3.5V20.5H4V3.5H3ZM3.5 21H20.5V20H3.5V21Z" fill="currentColor"/><Path d="M20.5 15H21V14H20.5V15ZM3.5 14H3V15H3.5V14ZM3.5 15H20.5V14H3.5V15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutBottomFull;
